export const scrollToHash = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -64, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

// Cross-page: after navigating to "/", the document is briefly short and Lenis
// clamps scroll targets to its stale limit. Force a resize, then wait until the
// target exists and Lenis's limit can actually reach it before scrolling.
export const scrollAfterNavigation = (hash, tries = 0) => {
  const el = hash === "body" ? document.body : document.querySelector(hash);
  const lenis = window.__lenis;
  lenis?.resize?.();
  if (el && lenis) {
    const target = el.getBoundingClientRect().top + window.scrollY - 64;
    if (lenis.limit >= target - 100) {
      scrollToHash(hash);
      return;
    }
  } else if (el && !lenis) {
    el.scrollIntoView({ behavior: "smooth" });
    return;
  }
  if (tries < 30) {
    setTimeout(() => scrollAfterNavigation(hash, tries + 1), 120);
  }
};
